import { render, staticRenderFns } from "./ChallengeFiles.vue?vue&type=template&id=ebc20db2&scoped=true"
import script from "./ChallengeFiles.vue?vue&type=script&lang=ts"
export * from "./ChallengeFiles.vue?vue&type=script&lang=ts"
import style0 from "./ChallengeFiles.vue?vue&type=style&index=0&id=ebc20db2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc20db2",
  null
  
)

export default component.exports